<template>
	<r-panel-container :title="`${tipoFormulario} autor`"
	                   icon="fal fa-books"
	                   :breadcrumb="breadcrumb">
		<template #toolbar>
			<button @click.prevent="guardar"
			        class="btn btn-dark btn-sm"
			        :disabled="deshabilitarFormulario">
				<template v-if="!guardando">
					<i class="fa fa-save"></i>
					Guardar
				</template>
				<template v-else>
					<i class="fa fa-sync fa-spin"></i>
					Guardando
				</template>
			</button>
		</template>
		<template #body>
			<div class="row">
				<div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 pt-3">
					<div class="mb-4">
						<r-input v-model="formularioAutor.info.nombre"
						         style-fill
						         :disabled="cargando || guardando"
						         placeholder="Nombre"/>
						<small class="text-danger" v-html="formularioAutor.errores.nombre"/>
					</div>
				</div>
			</div>
		</template>
	</r-panel-container>
</template>
<script setup lang="ts">
import {useNotify} from "base-app/dist/composable";
import {clearErrors, equals, showErrors} from "base-app/dist/utils";
import {useRoute, useRouter} from "vue-router";
import {computed, onMounted, ref} from "vue";
import {IFormulario} from "../../interfaces/IFormulario.ts";
import {Autores} from "../../api/Autores.ts";
import {IAutor} from "../../interfaces/IAutor.ts";
import {RInput, RPanelContainer} from "base-app/dist/components";

const breadcrumb = computed(() => ([
	{title: 'Autores', name: 'autores'},
	{title: tipoFormulario.value + ' autor'},
]));

const notify = useNotify();
const router = useRouter();
const route = useRoute();

const cargando = ref<boolean>(true);
const guardando = ref<boolean>(false);

const ultimosDatosFormulario = ref<IAutor>({
	nombre: '',
});
const formularioAutor = ref<IFormulario<IAutor>>({
	info: {
		nombre: '',
	},
	errores: {
		nombre: [],
	}
});

onMounted(async () => {
	await cargarTema();
});

const cargarTema = async () => {
	if (route.params.id) {
		cargando.value = true;
		try {
			const {data} = await Autores.porId(route.params.id as string);
			if (data.estado) {
				formularioAutor.value.info.nombre = data.info.nombre;
				ultimosDatosFormulario.value = JSON.parse(JSON.stringify(formularioAutor.value.info));
			} else {
				notify.error('!Oops!, ocurrio un error, ponte en contacto con el administrador del sistema.');
				volverAtras();
			}
		} catch {
			notify.error('!Oops!, ocurrio un error, ponte en contacto con el administrador del sistema.');
			volverAtras();
		} finally {
			cargando.value = false;
		}
	}
};

const guardar = async () => {
	guardando.value = true;
	clearErrors(formularioAutor.value.errores);
	try {
		let data;
		if (route.params.id) {
			formularioAutor.value.info.id = route.params.id as string;
			const resultado = await Autores.actualizar(formularioAutor.value.info);
			data = resultado.data;
		} else {
			const resultado = await Autores.nuevo(formularioAutor.value.info);
			data = resultado.data;
		}
		if (data.estado) {
			notify.success('Datos guardados con exito');
			volverAtras();
		} else {
			showErrors(data.mensajes, formularioAutor.value.errores);
		}
	} catch {
		notify.error('Error al intentar guardar');
		volverAtras();
	} finally {
		guardando.value = false;
	}
}
const volverAtras = () => {
	router.push({
		name: 'autores',
	});
};

const deshabilitarFormulario = computed(() => {
	return guardando.value === true || equals(ultimosDatosFormulario.value, formularioAutor.value.info);
});

const tipoFormulario = computed(() => {
	return route.params.id ? 'Editar' : 'Nuevo';
});
</script>